module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: [{
      'dark': _vm.isDarkMode
    }],
    attrs: {
      "id": "theme-selector"
    }
  }, [_c('h1', [_vm._v("Select a Theme!")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "available-themes"
    }
  }, _vm._l((_vm.availableThemes), function(theme) {
    return _c('div', {
      staticClass: "theme",
      class: [("theme-" + theme), {
        selected: theme == _vm.selectedTheme
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectTheme(theme)
        }
      }
    }, [_c('span', {
      staticClass: "regular-text"
    }, [_vm._v("A")]), _vm._v(" "), _c('span', {
      staticClass: "link"
    }, [_vm._v("A")])])
  }), 0), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleDarkMode($event)
      }
    }
  }, [_vm._v("Toggle Dark Mode")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePanel($event)
      }
    }
  }, [_vm._v("Close Theme Panel")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76949971"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ChatRoom/ThemeSelector.vue
// module id = 405
// module chunks = 1